import React from 'react'
import {FormattedNumber} from 'react-intl'

import {prosentAfter} from './index.css'

type ProsentProps = {
  prosent: number
}

export function Prosent(props: ProsentProps) {
  const {prosent} = props
  if (Number.isNaN(prosent)) {
    return <span>&mdash;</span>
  }
  return (
    <span className={prosentAfter}>
      <FormattedNumber value={prosent} minimumFractionDigits={1} />
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/Prosent/index.js